@if (isHandset$ | async) {
<mat-sidenav-container class="h-full">
  <mat-sidenav #drawer class="sidenav flex h-full" fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">
    <nas-navbar-vertical class="left-navbar flex-1" footerText="© ANA SEGUROS 2025 Versión {{version.full}}"
      [items]="navItems" logoText="ANA Claims®" />
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="flex flex-1 flex-col">
      <mat-toolbar color="primary">
        <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
          <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
        </button>
        <h1 class="block sm:hidden font-bold! text-2xl!">{{title}}</h1>
        <nas-breadcrumb class="hidden sm:block!" />
        <span class="spacer"></span>
        @if (userProfile) {
        <a class="toolbar-composite-button" tabindex="-1" [matMenuTriggerFor]="userMenuSm">
          <span class="toolbar-avatar">
            <img src="images/profile.png">
          </span>
        </a>
        }
      </mat-toolbar>
      <div class="flex flex-1 flex-col overflow-y-auto">
        <nas-breadcrumb
          class="block sm:hidden m-0 p-3 pb-0 flex items-center text-sm font-bold bg-tertiary text-white" />
        <router-outlet />
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
} @else {
<mat-sidenav-container class="h-full">
  <mat-sidenav-content>
    <div class="flex flex-row h-full overflow-hidden">
      <nas-navbar-vertical class="mat-app-background left-navbar"
        footerText="© ANA SEGUROS 2025 Versión {{version.full}}" [items]="navItems" logoText="ANA Claims®"
        [ngClass]="{'folded': navbarFolded, 'open': navbarOpen}" (toggleFold)="setNavbarFolded($event)"
        (toggleOpen)="setNavbarOpen($event)" role="navigation" />
      <div class="flex flex-1 flex-col overflow-y-auto"
        [ngStyle]="{'margin-left': navbarFolded ? '64px' : '0', 'width': navbarFolded ? 'calc(100% - 64px)' : navbarOpen ? 'calc(100% - 299px)' : '100%'}">
        <mat-toolbar class="flex-none" color="primary">
          <nas-breadcrumb />
          <span class="spacer"></span>
          @if (userProfile) {
          <a class="toolbar-composite-button" tabindex="-1" [matMenuTriggerFor]="userMenu">
            <span class="toolbar-avatar">
              <img src="images/profile.png">
            </span>
            <span class="text-base font-semibold">{{userProfile.firstName}} {{userProfile.lastName}}</span>
            <span class="icon">
              <fa-icon [icon]="faAngleDown" [fixedWidth]="true" aria-hidden="true" />
            </span>
          </a>
          }
        </mat-toolbar>
        <router-outlet />
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
}

<mat-menu #userMenu="matMenu" class="shadow-md" xPosition="before">
  <button mat-menu-item (click)="logout()">
    <fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" role="img" size="lg" aria-hidden="true" />
    <span>Salir</span>
  </button>
</mat-menu>
<mat-menu #userMenuSm="matMenu" class="shadow-md" xPosition="before">
  @if (userProfile) {
  <span class="text-sm font-normal m-2">{{userProfile.firstName}} {{userProfile.lastName}}</span>
  }
  <button mat-menu-item (click)="logout()">
    <fa-icon [icon]="faRightFromBracket" [fixedWidth]="true" role="img" size="lg" aria-hidden="true" />
    <span>Salir</span>
  </button>
</mat-menu>